import configData from "../config.json";

class CommonService {

    async getLabels(): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const response = await fetch(configData.API + "/frontendLabels?lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getHeaderMenu(): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const response = await fetch(configData.API + "/frontendGroups?lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async translate(key: string): Promise<string> {
        const translations = window.localStorage.getItem('translations');
        if (translations) {
            const dict = JSON.parse(translations) as Array<any>;
            const found = dict.filter(item => item.setting_name === key);
            if (found && found.length > 0) {
                return found[0].setting_value_text;
            }
        } else {
            const fetched = await this.getLabels();
            window.localStorage.setItem('translations', JSON.stringify(fetched));
            const found = fetched.filter((item: any) => item.setting_name === key);
            if (found && found.length > 0) {
                return found[0].setting_value_text;
            }
        }
        throw new Error(`Translation for key "${key}" not found.`);
    }

    async getProducts(groupID: string): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const serviceID = groupID === 'hop-on' ? 1 : 2;
            const response = await fetch(configData.API + "/frontendProducts?groupID=" + serviceID + "&lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getEvents(group: string): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const response = await fetch(configData.API + "/frontendEvents?groupID=" + group + "&lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getMenus(eventID: string): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const response = await fetch(configData.API + "/frontendMenus?eventID=" + eventID + "&lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getUID(): Promise<Record<string, any>> {
        try {
            const response = await fetch(configData.API + "/frontendInit");
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch UID:", error);
            throw error;
        }
    }

    async getHotels(): Promise<Record<string, any>> {
        try {
            const response = await fetch(configData.API + "/frontendHotels");
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getCountries(): Promise<Record<string, any>> {
        try {
            const response = await fetch(configData.API + "/frontendCountries");
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getPaymentStatus(uuid: string): Promise<Record<string, any>> {
        try {
            const response = await fetch(configData.API + "/frontendPaymentStatus?uuid=" + uuid);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async getPage(pageID: string): Promise<Record<string, any>> {
        try {
            const lang = localStorage.getItem('language') || 'en';
            const response = await fetch(configData.API + "/frontendContents?pageID=" + pageID + "&lang=" + lang);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

    async authenticateUser(username: string, password: string): Promise<Record<string, any>> {
        try {
            const response = await fetch(configData.API + "/authenticate", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ user: username, pass: password })
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to authenticate user:", error);
            throw error;
        }
    }

    async createOrder(orderData: any): Promise<any> {
        try {
            const response = await fetch(configData.API + "/frontendCreateOrderDetails", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(orderData)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to create order record:", error);
            throw error;
        }
    }

    async validateUUID(uuid: string): Promise<{ valid: boolean; uuid: string | null }> {
        try {
            const response = await fetch(configData.API + "/frontendValidateUUID?uuid=" + uuid);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to validate UUID:", error);
            throw error;
        }
    }

    async getQRCodes(uuid: string): Promise<Array<any>> {
        try {
            const response = await fetch(configData.API + "/frontendQRCodes?orderID=" + uuid);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Failed to fetch labels:", error);
            throw error;
        }
    }

}

export default CommonService;